"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApSelect = void 0;
var React = require("react");
var ApIcon_1 = require("../ApIcon");
var ApSelect_styles_1 = require("./ApSelect.styles");
exports.ApSelect = function (_a) {
    var disabled = _a.disabled, name = _a.name, onChange = _a.onChange, options = _a.options, placeholder = _a.placeholder, value = _a.value, props = __rest(_a, ["disabled", "name", "onChange", "options", "placeholder", "value"]);
    return (React.createElement(ApSelect_styles_1.Wrapper, null,
        React.createElement(ApSelect_styles_1.Arrow, null,
            React.createElement(ApIcon_1.ApIcon, { iconName: "baseline_arrow_drop_down" })),
        React.createElement(ApSelect_styles_1.Select, __assign({ disabled: disabled, id: "select-" + name, value: value, onChange: function (e) { onChange(e.target.value); } }, props),
            placeholder ? React.createElement("option", { value: "", hidden: true }, placeholder) : null,
            options.map(function (opt) { return (React.createElement("option", { key: "name-dropdown-" + opt.value + "-" + opt.label, value: opt.value }, opt.label)); }))));
};
//# sourceMappingURL=ApSelect.js.map